import { createI18n } from 'vue-i18n';

const ja = require('../../public/message/LanguageJp.json');

const messages = {
    ja: ja,
};

const i18n = createI18n({
    // デフォルトで日本語を使用する
    locale: 'ja',
    messages: messages,
});

export default i18n;
